import { all, takeLatest } from 'redux-saga/effects';
import { ACTIONS as mainActions } from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r';
import { types as headerActions } from '@gerenciatd/next.app-controller.reducers-sagas.header-reducer-r';
import { types as modalsAnchorActions } from '@gerenciatd/next.app-controller.reducers-sagas.modals-reducer';
import {
  initAnchorModalListener,
  addModal,
} from '@gerenciatd/next.app-controller.reducers-sagas.modals-saga-n';
import {
  getSearcherInfo,
  getRelatedPages,
} from '@gerenciatd/next.app-controller.reducers-sagas.header-saga-r';
import { getFooterInfo } from '@gerenciatd/next.app-controller.reducers-sagas.header-saga';
import {
  getSeo,
  checkCPAndSetZones,
} from '@gerenciatd/next.app-controller.reducers-sagas.main-saga-r';


function* rootSaga() {
  yield all([
    /* BASICS */
    takeLatest(mainActions.GET_CURRENT_SEO, getSeo),
    /* HEADER */
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    takeLatest(headerActions.GET_FOOTER_INFO, getFooterInfo),
    takeLatest(headerActions.GET_SEARCHER_INFO, getSearcherInfo),
    takeLatest(headerActions.GET_RELATED_PAGES, getRelatedPages),
    // ANCHOR MODAL
    takeLatest(modalsAnchorActions.INIT_ANCHOR_MODAL, initAnchorModalListener),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
  ]);
}

export default rootSaga;
